import { Order } from '@instamenu/data-access';
import { Columns } from '@instamenu/ui-system-next';
import { columnsFlex } from '../menu/menu-view.css';
import { OrderHistoryCard } from './order-history-card';

export const OrderHistory = ({ orders }: { orders: Order[] }) => {
  return (
    <Columns style={{ marginBottom: 20 }} className={columnsFlex}>
      {orders.map((order) => (
        <OrderHistoryCard key={order.id} order={order} />
      ))}
    </Columns>
  );
};
